<template>
  <div>
    <!-- <div class="text-section-header">
      {{ this.filterableTaxonomiesData.label }}
    </div> -->
    <v-autocomplete
      chips
      clearable
      deletable-chips
      multiple
      :hide-details="true"
      :label="filterableTaxonomiesData.label"
      :value="selectedValues"
      :items="termsItems"
      @input="handleInput"
    />
  </div>
</template>

<script>
// vuex
import { mapGetters, mapActions } from 'vuex'
// library
import _ from 'lodash'
// internal

// components
export default {
  name: 'SearchFilterAutocomplete',
  props: {
    filterableTaxonomiesData: {
      type: Object,
      require: true
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['taxonomies', 'projectTermFilters']),
    taxonomyValue() {
      return this.filterableTaxonomiesData.value
    },
    terms() {
      return this.taxonomies[this.taxonomyValue]
    },
    termsItems() {
      return this.terms.map(el => {
        return {
          text: `${el.name}`,
          value: el.term_taxonomy_id
        }
      })
    },
    selectedValues() {
      return this.projectTermFilters[this.taxonomyValue]
    }
  },
  watch: {},
  mounted() {
    if (this.projectTermFilters[this.taxonomyValue] === undefined) {
      this.handleInput([])
    }
  },
  methods: {
    ...mapActions(['setProjectTermFilters']),
    handleInput(v) {
      const newVals = { ...this.projectTermFilters }

      if (_.isEmpty(v)) {
        if (!newVals[this.taxonomyValue]) {
          newVals[this.taxonomyValue] = false
        } else {
          newVals[this.taxonomyValue] = false
          const newQuery = _.omit({ ...this.$route.query }, [
            this.taxonomyValue
          ])
          this.$router.history.push({ path: '/', query: newQuery })
        }
      } else {
        newVals[this.taxonomyValue] = [...v]

        const newQuery = { ...this.$route.query }
        newQuery[this.taxonomyValue] = v.join(',')
        this.$router.history.push({ path: '/', query: newQuery })
      }
      this.setProjectTermFilters(newVals)
    }
  }
}
</script>

<style lang="scss" scoped></style>
